import { render, staticRenderFns } from "./huawei.vue?vue&type=template&id=423831ad&scoped=true"
import script from "./huawei.vue?vue&type=script&lang=js"
export * from "./huawei.vue?vue&type=script&lang=js"
import style0 from "./huawei.vue?vue&type=style&index=0&id=423831ad&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423831ad",
  null
  
)

export default component.exports